import { Container } from "aurelia-dependency-injection";
import { defineComponent } from "vue";

import { LocationService } from "../../../../../../../services/location-service";
import { ToastrService } from "../../../../../../../services/toastr.service";
import { PalServiceLocations } from "../../../../../../../enums/PalServiceLocationsEnum";
import { formatDate } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";

import TablePrompt from "../../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import AddServiceLocationForm from "../AddServiceLocationForm/AddServiceLocationForm.vue";
import EmptyTextHandler from "../../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";

export default defineComponent({
    components: {
        TablePrompt,
        AddServiceLocationForm,
        EmptyTextHandler
    },
    props: {
        resetList: {
            type: Function
        },
        columns: {
            type: Number
        },
        patientDetails: {
            type: Object
        },
        service: {
            type: Object
        },
        application: {
            type: Number
        },
        accountId: {
            type: String
        },
        patientId: {
            type: String
        },
        closeServiceForm: {
            type: Function
        },
        itemCount: {
            type: Number
        }
    },

    data(vm) {
        return {
            isDeleteRequested: false,
            isEditRequested: false,
            isDeleteInProgress: false,
            _serviceLocationService: null,
            _toastrService: null,
            PalServiceLocationsEnum: PalServiceLocations,
            cachedData: null,
            formatDate
        };
    },

    created() {
        this._serviceLocationService = Container.instance.get(LocationService);
        this._toastrService = Container.instance.get(ToastrService);
    },
    methods: {
        openServiceForm() {
            this.isEditRequested = true;
        },
        confirmDeleteService() {
            this.isDeleteRequested = true;
        },
        closeEditService() {
            this.isEditRequested = false;
        },
        cancelDeleteService() {
            this.isDeleteRequested = false;
        },
        openEditServiceLocation() {
            this.isEditRequested = true;
        },
        async deleteServiceLocation() {
            try {
                this.isDeleteInProgress = true;
                await this._serviceLocationService.deleteServiceLocation(
                    {
                        agencyId: this.accountId,
                        application: this.application
                    },
                    this.patientId,
                    this.service.Id
                );
                this.resetList();
                this._toastrService.success({
                    title: "Success",
                    message: "Service Location has been successfully deleted!"
                });
            } catch (err) {
                console.error(err);
                this._toastrService.error({
                    title: `Error`,
                    message: `There was a problem while deleting the service. Please try again.`
                });
            } finally {
                this.isDeleteInProgress = false;
                this.isDeleteRequested = false;
            }
        }
    }
});
